import { render, staticRenderFns } from "./PropertiesView.vue?vue&type=template&id=46e8cd74&scoped=true"
import script from "./PropertiesView.vue?vue&type=script&lang=js"
export * from "./PropertiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8cd74",
  null
  
)

export default component.exports